import createIcon from '../../createIcon';

/**
 * @component @name Visibility
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNC41QzcgNC41IDIuNzMgNy42MSAxIDEyQzIuNzMgMTYuMzkgNyAxOS41IDEyIDE5LjVDMTcgMTkuNSAyMS4yNyAxNi4zOSAyMyAxMkMyMS4yNyA3LjYxIDE3IDQuNSAxMiA0LjVaTTEyIDE3QzkuMjQgMTcgNyAxNC43NiA3IDEyQzcgOS4yNCA5LjI0IDcgMTIgN0MxNC43NiA3IDE3IDkuMjQgMTcgMTJDMTcgMTQuNzYgMTQuNzYgMTcgMTIgMTdaTTEyIDlDMTAuMzQgOSA5IDEwLjM0IDkgMTJDOSAxMy42NiAxMC4zNCAxNSAxMiAxNUMxMy42NiAxNSAxNSAxMy42NiAxNSAxMkMxNSAxMC4zNCAxMy42NiA5IDEyIDlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Visibility = createIcon('Visibility', [
  [
    'path',
    {
      d: 'M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z',
      key: 'yj4qwc',
    },
  ],
]);

export default Visibility;
